import { toString } from "lodash";

export function getFractionalPart(value: number): string {
  return toString(value).replace(/(\d+)(\.)?(\d+)?/g, (_, __, ___, p3) => p3 || "");
}
